import { INIT, SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAILED, RESET_DIALOG } from './constants';

export const initAction = () => ({ type: INIT });

export const submitAction = (token, password) => ({
  type: SUBMIT,
  token,
  password,
});
export const submitSuccessAction = () => ({ type: SUBMIT_SUCCESS });
export const submitFailedAction = (error, errorCode) => ({
  type: SUBMIT_FAILED,
  error,
  errorCode,
});

export const resetDialogAction = () => ({ type: RESET_DIALOG });
